import { usePlausiblePrivacy } from '~/composables/usePlausiblePrivacy';
import { usePrivacyConsent } from '~/composables/usePrivacyConsent';
import { onMounted, watch } from 'vue';
import { useI18n } from 'vue-i18n';
import {
  funnelPayload,
  pushFunnelEvent,
  dispatchFunnelEvent
} from '~/utils/conversion';

export function useConversionTracking() {
  const { locale } = useI18n();
  const plausible = usePlausiblePrivacy();
  const { analyticsAllowed: consent, syncFromCookie } = usePrivacyConsent();
  const track = (event, data) => {
    if (!import.meta.client) return false;
    syncFromCookie();
    return pushFunnelEvent(
      window,
      consent.value,
      funnelPayload(event, locale.value, data)
    );
  };
  // Track the current visible state once per product/language and component visit.
  // Consent given later records that state, never a history of declined clicks.
  const trackView = (event, getData) => {
    const sentGoogle = new Set();
    const sentPlausible = new Set();
    onMounted(() => {
      watch(
        [getData, consent, locale, plausible.optedOut],
        ([data]) => {
          if (!consent.value) sentGoogle.clear();
          if (!data) return;
          const key = `${locale.value}:${data.itemId}:${data.duration || ''}:${data.currency || ''}:${data.value ?? ''}`;
          const result = dispatchFunnelEvent(
            window,
            consent.value,
            funnelPayload(event, locale.value, data),
            {
              google: !sentGoogle.has(key),
              plausible: !sentPlausible.has(key)
            }
          );
          if (result.google) sentGoogle.add(key);
          if (result.plausible) sentPlausible.add(key);
        },
        { immediate: true }
      );
    });
  };
  return { track, consent, trackView };
}
